export const COEFF_INFO = {
    work: {
        'k1': {color: 'navy', description: 'коэфф. (разн.) места работы'},
        'k2': {color: 'olive', description: 'коэфф. (разн.) оборудования'},
        'k3': {color: 'orange', description: 'коэфф. (разн.) вида работы'},
        'k4': {color: 'fuchsia', description: 'коэфф. (соотв.) вида дня'},
        'k5': {color: 'maroon', description: 'персональный коэфф.'},
    },
    complement: {
        'k1': {color: 'navy', description: 'коэфф. (соотв.) доп. часов'},
        'k2': {color: 'olive', description: 'коэфф. вида дня'},
    },
    travel: {
        'k1': {color: 'navy', description: 'коэфф. (соотв.) дор. часов'},
    }
};

export const STATUS_DESCRIPTION = {
    ILLNESS: 'Больничный',
    ILLNESS_PENDING: 'Больничный (пока не подтвержден)',
    VACATION_PAID: 'Оплачиваемый отпуск',
    VACATION_PAID_PENDING: 'Оплачиваемый отпуск (пока не одобрен)',
    VACATION_UNPAID: 'Отпуск за свой счет',
    VACATION_UNPAID_PENDING: 'Отпуск за свой счет (пока не одобрен)',
    TIME_OFF_PAID: 'Оплачиваемый отгул',
    TIME_OFF_PAID_PENDING: 'Оплачиваемый отгул (пока не подтвержден)',
    TIME_OFF_UNPAID: 'Неоплачиваемый отгул',
    TIME_OFF_UNPAID_PENDING: 'Неоплачиваемый отгул (пока не подтвержден)',
    WORK_FROM_HOME: 'Работа из дома',
    WORK_FROM_HOME_NWD: 'Работа из дома в нерабочий день',
    WORK_FROM_OFFICE: 'Работа из офиса',
    WORK_FROM_OFFICE_NWD: 'Работа из офиса в нерабочий день',
    FIELD_WORK_HOME_CITY: 'Работа в СПб',
    FIELD_WORK_HOME_CITY_NWD: 'Работа в СПб в нерабочий день',
    FIELD_WORK_OTHER_CITY: 'Командировка',
    FIELD_WORK_OTHER_CITY_NWD: 'Командировка в нерабочий день',
    ON_THE_ROAD: 'День в дороге',
    ON_THE_ROAD_NWD: 'День в дороге в нерабочий день',
    EMPTY: 'Ничего не указано :(',
};